import React from 'react';

import { SidePage, Section } from '@gogame/components';

import Actions from 'scenes/Gallery/GalleryPage/ConceptFamilies/Actions';
import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';
import { DetailsFile } from 'scenes/Gallery/components/File';
import {
  HEIGHT,
  ROOT_HTML_URL,
  URL,
  WIDTH,
} from 'scenes/Gallery/components/File/constants';

import ConceptFamilyDetailsGeneral from './ConceptFamilyDetailsGeneral';
import ConceptFamilyDetailsInfo from './ConceptFamilyDetailsInfo';

const ConceptFamilyDetails = ({ data = {}, onDelete, openChildComponent }) => {
  const {
    [CONCEPT_FAMILY.CONCEPTS_COUNT]: conceptsCount,
    [CONCEPT_FAMILY.CREATIVES_COUNT]: creativesCount,
    [CONCEPT_FAMILY.ORIGINAL]: original,
  } = data;

  const {
    [CREATIVE.FILE]: originalFile,
    [CREATIVE.CREATIVE_TYPE]: originalCreativeTypeId,
  } = original || {};

  const {
    [URL]: fileUrl,
    [ROOT_HTML_URL]: fileRootHtmlUrl,
    [WIDTH]: fileWidth,
    [HEIGHT]: fileHeight,
  } = originalFile || {};

  return (
    <SidePage.NewBody wrapper={true}>
      <SidePage.NewContent withSidebar={true}>
        <DetailsFile
          src={fileRootHtmlUrl || fileUrl}
          width={fileWidth}
          height={fileHeight}
          maxWidth={688}
          maxHeight={400}
          creativeTypeId={originalCreativeTypeId}
          attributes={
            <AttributeList type={'text'} listSeparator={'|'}>
              <AttributeItem
                valueParser={'conceptsCount'}
                value={conceptsCount}
              />
              <AttributeItem
                valueParser={'creativesCount'}
                value={creativesCount}
              />
            </AttributeList>
          }
        />
        <Section title={'General'}>
          <ConceptFamilyDetailsGeneral data={data} />
        </Section>
      </SidePage.NewContent>
      <SidePage.Sidebar
        actions={
          <Actions
            actions={data?.actions}
            data={data}
            onRemove={onDelete}
            onOpenChildComponent={openChildComponent}
          />
        }
      >
        <ConceptFamilyDetailsInfo data={data} variant={'column'} />
      </SidePage.Sidebar>
    </SidePage.NewBody>
  );
};

export default ConceptFamilyDetails;
